import React, { Component } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import {
    Paper,
    Grid,
    List,
    Avatar,
    ListItem,
    ListItemText,
    Typography,
    ListItemAvatar,
    Tab,
    Tabs,
    Button,
} from "@material-ui/core";
import { connect } from "react-redux";

import { getRegisteredUsers, getGroups } from "./actions";

import { hot } from "react-hot-loader";
// const styles = () => ({
//     addUserModel: {
//         width: "60%",
//     },
//     list: {
//         width: "100%",
//         marginTop: 15,
//         marginBottom: 1,
//         borderRadius: 5,
//         backgroundColor: "#3f51b5",
//     },
//     listItem: {
//         width: "auto",
//         backgroundColor: "white",
//         marginLeft: 10,
//         marginRight: 10,
//         borderRadius: 5,
//         marginBottom: 1,
//         marginTop: 1,
//         padding: 0,
//     },
//     table: {
//         minWidth: 500,
//     },
//     tableWrapper: {
//         overflowX: "auto",
//     },
//     form: {
//         position: "relative",
//         width: "90%",
//     },
//     MessageList: {
//         width: "100%",
//         backgroundColor: "#dddddd",
//     },
//     MessageItem: {
//         width: "auto",
//         margin: 12,
//         backgroundColor: "#fff",
//         borderRadius: 6,
//         overflowWrap: "break-word",
//     },
// });
class MessengerWidget extends Component {
    constructor(props) {
        super(props);
        props.getRegisteredUsers();
        props.getGroups();

        this.state = {
            tabVal: 0,
            MessageColors: [],
            colorNo: 0,
        };
    }
    componentDidUpdate(prevProps) {
        if (prevProps.groups !== this.props.groups) {
            this.setState({
                colorsNo: this.props.groups[this.state.tabVal]
                    ? this.props.groups[this.state.tabVal].users_in_group.length
                    : 0,
            });

            this.generateColors(
                this.props.groups[this.state.tabVal]
                    ? this.props.groups[this.state.tabVal].users_in_group
                    : []
            );
        }
    }
    getInitials(name) {
        if (typeof name === "undefined") return "NA";

        let first = name.split(" ")[0][0];
        let last = name.split(" ")[name.split(" ").length - 1][0];
        return `${first}${last}`;
    }
    getColor(uid) {
        const { MessageColors } = this.state;

        for (let i = 0; i < MessageColors.length; i++) {
            if (MessageColors[i].uid === uid) return MessageColors[i].color;
        }
    }
    generateColors(users = 0) {
        const { MessageColors } = this.state;

        let cols = MessageColors;
        for (let i = 0; i < users.length; i++)
            cols.push({
                color: `rgb(${this.genRandomNumber(
                    0,
                    255
                )},${this.genRandomNumber(0, 255)},${this.genRandomNumber(
                    0,
                    255
                )})`,
                uid: users[i],
            });

        this.setState({ MessageColors: cols });
    }
    genRandomNumber(min, max) {
        let random_number = Math.random() * (max - min) + min;
        return Math.floor(random_number);
    }
    getNameofUser(uid) {
        const users = this.props.users === [] ? false : this.props.users;

        for (let i = 0; i < users.length; i++) {
            if (users[i].uid === uid) {
                return users[i].name;
            }
        }
        //return typeof name === "undefined" ? "Unknown" : name;
    }
    render() {
        const { sm, md, lg, groups } = this.props;

        const { tabVal } = this.state;
        return (
            <Grid item sm={sm} md={md} lg={lg}>
                <Paper
                    style={{
                        borderRadius: 0,
                        position: "relative",
                        overflow: "hidden",
                        height: "450px",
                    }}
                >
                    <Typography variant="h6" style={{ padding: 24 }}>
                        Messenger Groups
                    </Typography>
                    <Tabs
                        indicatorColor="primary"
                        textColor="primary"
                        value={tabVal}
                        onChange={(event, value) => {
                            this.setState({ tabVal: value });
                        }}
                        style={{ borderWidth: 0 }}
                        scrollable
                        scrollButtons="auto"
                    >
                        {groups &&
                            groups.map((e, i) => {
                                return <Tab label={e.group_name} value={i} />;
                            })}
                    </Tabs>
                    {groups &&
                        groups.map((e, i) => {
                            if (i === tabVal) {
                                return (
                                    <List
                                        style={{
                                            overflowY: "scroll",
                                            height: "332px",
                                            width: "100%",
                                            backgroundColor: "#dddddd",
                                        }}
                                    >
                                        {groups[i].messages_in_group &&
                                            Object.keys(
                                                groups[i].messages_in_group
                                            )
                                                .sort()
                                                .reverse()
                                                .map((e) => {
                                                    return (
                                                        <ListItem
                                                            style={{
                                                                width: "auto",
                                                                margin: 12,
                                                                backgroundColor: "#fff",
                                                                borderRadius: 6,
                                                                overflowWrap: "break-word",
                                                            }}
                                                            alignItems="flex-start"
                                                        >
                                                            <ListItemAvatar>
                                                                <Avatar
                                                                    style={{
                                                                        backgroundColor: `${this.getColor(
                                                                            groups[
                                                                                i
                                                                            ]
                                                                                .messages_in_group[
                                                                                e
                                                                            ]
                                                                                .sender
                                                                        )}`,
                                                                    }}
                                                                >
                                                                    {" "}
                                                                    {this.getInitials(
                                                                        this.getNameofUser(
                                                                            groups[
                                                                                i
                                                                            ]
                                                                                .messages_in_group[
                                                                                e
                                                                            ]
                                                                                .sender
                                                                        )
                                                                    )}{" "}
                                                                </Avatar>
                                                            </ListItemAvatar>
                                                            <ListItemText
                                                                primary={this.getNameofUser(
                                                                    groups[i]
                                                                        .messages_in_group[
                                                                        e
                                                                    ].sender
                                                                )}
                                                                secondary={
                                                                    <React.Fragment>
                                                                        {groups[
                                                                            i
                                                                        ]
                                                                            .messages_in_group[
                                                                            e
                                                                        ]
                                                                            .attatched_image_url && (
                                                                            <img
                                                                                style={{
                                                                                    position:
                                                                                        "relative",
                                                                                    width:
                                                                                        "auto",
                                                                                    margin: 12,
                                                                                    height:
                                                                                        "130px",
                                                                                    cursor:
                                                                                        "pointer",
                                                                                }}
                                                                                onClick={() => {
                                                                                    this.setState(
                                                                                        {
                                                                                            isOpen: true,
                                                                                            modalImg:
                                                                                                groups[
                                                                                                    i
                                                                                                ]
                                                                                                    .messages_in_group[
                                                                                                    e
                                                                                                ]
                                                                                                    .attatched_image_url,
                                                                                        }
                                                                                    );
                                                                                }}
                                                                                src={
                                                                                    groups[
                                                                                        i
                                                                                    ]
                                                                                        .messages_in_group[
                                                                                        e
                                                                                    ]
                                                                                        .attatched_image_url
                                                                                }
                                                                                alt="attachment"
                                                                            />
                                                                        )}
                                                                        {
                                                                            groups[
                                                                                i
                                                                            ]
                                                                                .messages_in_group[
                                                                                e
                                                                            ]
                                                                                .message
                                                                        }
                                                                        <br />
                                                                        {
                                                                            groups[
                                                                                i
                                                                            ]
                                                                                .messages_in_group[
                                                                                e
                                                                            ]
                                                                                .timestamp
                                                                        }
                                                                    </React.Fragment>
                                                                }
                                                            />
                                                        </ListItem>
                                                    );
                                                })}
                                    </List>
                                );
                            } else return null;
                        })}
                    <Modal isOpen={this.state.isOpen}>
                        <ModalHeader>Photo Viewer</ModalHeader>
                        <ModalBody>
                            {this.state.modalImg && (
                                <img
                                    style={{
                                        position: "relative",
                                        width: "100%",
                                        margin: 12,
                                        height: "auto",
                                    }}
                                    src={this.state.modalImg}
                                    alt="attachment"
                                />
                            )}
                        </ModalBody>
                        <ModalFooter>
                            <Button
                                onClick={() => {
                                    this.setState({
                                        isOpen: false,
                                        modalImg: false,
                                    });
                                }}
                                variant="contained"
                            >
                                Close
                            </Button>
                        </ModalFooter>
                    </Modal>
                </Paper>
            </Grid>
        );
    }
}

export default hot(module)(
    connect(
        (store, props) => {
            const { selectors } = props;
            const { selectRegisteredUsers, selectGroup } = selectors;

            return {
                users: selectRegisteredUsers(store),
                groups: selectGroup(store),
            };
        },
        { getRegisteredUsers, getGroups }
    )(MessengerWidget)
);
